// @flow

export default class {
  a: number;
  b: number;
  c: number;
  d: number;
  isAcend: boolean;

  // f(x) = b * (x^d + c) / (a + x^d + c)
  constructor(
    sqrtA: number,
    b: number,
    c: number,
    d: number,
    isAcend: boolean
  ) {
    // a を直接設定する形にすると数が大きすぎて設定が大変そうなので平方根を受け取るようにしているが
    // 細かい調整の必要性が発生してきたらここは再検討する
    this.a = sqrtA * sqrtA;
    this.b = b;
    this.c = c;
    this.d = d || 2; // 基本的には2を使う
    this.isAcend = isAcend === undefined ? false : isAcend;
  }

  calculate(value: number): number {
    // 0では割れない
    // TODO: isAcend == true の時、1 を返す必要がないか要検証
    if (this.a == 0 && this.c == 0 && value == 0) return 0;

    let result: number =
      (this.b * (Math.pow(value, this.d) + this.c)) /
      (this.a + Math.pow(value, this.d) + this.c);

    result = this.isAcend ? 1 - result : result;

    if (result < 0) {
      result = 0;
    } else if (result > 1) {
      result = 1;
    }

    return result;
  }

  judge(value: number): boolean {
    return Math.random() < this.calculate(value);
  }

  getString(): string {
    const bStr: string = this.b == 1 ? '' : `${this.b}*`;
    const cStr: string = this.c == 0 ? '' : ` + ${this.c}`;
    let numerator: string = `(x<sup>${this.d}</sup>${cStr})`; // 分子
    if (!numerator.match(/\+/)) numerator = numerator.replace(/[\(\)]/g, ''); // 分子に項が1つしかない場合はカッコを消す
    const denominator: string = `(${this.a} + x<sup>${this.d}</sup>${cStr})`; // 分母
    const formula: string = `${bStr + numerator} / ${denominator}`;
    if (this.isAcend) return `1 - ${formula}`;
    return formula;
  }

  getSampleData(start: number, end: number): Array<number> {
    const results: Array<number> = [];
    for (let i = start; i <= end; i++) {
      results.push(this.calculate(i));
    }
    return results;
  }
}



// WEBPACK FOOTER //
// ./src/lib/condition/hill_condition.js